import { React, Axios, Link, $, dt, Select } from "../../../Headers";
import FullLoader from "../../Common/FullLoader";

export default class WebBookHome extends React.Component {
  constructor() {
    super();
    this.state = {
      booksData: [],
      categoryData: [],
      server: "",
      selectedCategory: [{ value: null, label: "All Categories" }],
      loading: false,
    };
  }

  componentDidMount() {
    const server = window.$name;
    //console.log(server);
    this.setState({ server: server });
    Axios.post("//" + window.$name + "/controller/GetWebBookController.php")
      .then((res) => {
        this.setState({ booksData: res.data });
      })
      .catch((error) => {
        console.log(error[0]);
      });

    Axios.post(
      "//" + window.$name + "/controller/GetWebCategoryController.php",
      {}
    )
      .then((res) => {
        this.setState({ categoryData: res.data });
      })
      .catch((error) => {
        console.log(error[0]);
      });
  }

  getBookDataCategoryWise = async (value) => {
    this.setState({ loading: true });

    await Axios.post(
      "//" + window.$name + "/controller/GetWebBookController.php",
      {
        category: value,
      }
    )
      .then((res) => {
        this.setState({ booksData: res.data });
        this.setState({ loading: false });
      })
      .catch((error) => {
        console.log(error[0]);
        this.setState({ loading: false });
      });
  };

  handleChangeCategory = async (selectedValue) => {
    this.setState({ selectedCategory: selectedValue });
    await this.getBookDataCategoryWise(selectedValue.value);
  };

  render() {
    return (
      <>
        {this.state.loading && <FullLoader />}
        <div className="row mb-5">
          <div className="col-12">
            <div className="book-category-drop-down-outer">
              <Select
                className="book-category-drop-down"
                onChange={this.handleChangeCategory}
                options={this.state.categoryData}
                value={this.state.selectedCategory}
                placeholder="Select Category"
              />
            </div>
            <div
              class="row mt-3"
              style={{
                justifyContent: "center",
                margin: "0",
                width: "inherit",
              }}
            >
              {this.state.booksData.length > 0 &&
                this.state.booksData.map((data) => (
                  <div className="col-lg-3 col-sm-12 sort-card">
                    <Link to={"/book/" + data.bookId + "/specific"}>
                      {/* <div class="hover_color_bubble"></div> */}
                      <div
                        class="so_top_icon zoom-hover"
                        style={{
                          width: "100%",
                          height: "45%",
                          borderRadius: "15px 15px 0 0",
                          backgroundImage:
                            "url(" +
                            window.$file +
                            "webBooks/" +
                            data?.image +
                            ")",
                          backgroundSize: "cover",
                        }}
                      ></div>
                      <div style={{ padding: "25px", height: "55%" }}>
                        <div class="sort-card-title">{data.title}</div>

                        <div
                          class="sort-card-content"
                          style={{ height: "70%", overflow: "auto" }}
                        >
                          {data.about}
                        </div>
                        {/* <button  type="button">
              <Link to={'/journalspecific/'+data.journal_id} target="_blank" >Read More</Link></button> */}
                        {/* <div style={{ paddingTop: "5px" }}>
                      Last Updated on 2 Oct 2021
                    </div> */}
                      </div>
                    </Link>
                  </div>
                ))}

              {this.state.booksData.length === 0 && !this.state.loading && (
                <div className="no-record">No result found</div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
}
